import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import { AppHelper } from "../appHelper";
import { StringKeyDictionary } from "../commonInterfaces";
import { AppBaseProps, CommonApp, Context, Entity } from "../core/components/commonApp";
import { Grid } from "../core/components/grid";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar";
import { Config } from "../core/config/config";
import { DialogHelper } from "../core/util/dialogHelper";
import { Helper } from "../core/util/helper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { NotificationHelper } from "../core/util/notificationHelper";
import { CreateTravelReportApp, CreateTravelReportEntity, CreateTravelReportProps } from "./createTravelReport";
import { TravelReportEntity, TravelReportFilter, TravelReportRights } from "./travelReportInterfaces";
import React from "react";

export class TravelReportSearchApp extends React.Component<TravelReportSearchProps, TravelReportSearchState> {
    common = new AppHelper();
    translations: StringKeyDictionary<string> = null;
    travelReportGridOptions = {};

    constructor(props: TravelReportSearchProps) {
        super(props);
        this.common.init(this);
        this.state = {
            Filter: this.props.entity.Filter,
            SelectedTravelReport: null,
            TravelReportVms: null
        }
    }

    componentDidMount = () => {
        this.getTravelReportVms();
    }

    getTravelReportVms = async () => {
        let result = await HTTPService.get<JsonResultClass<TravelReportEntity[]>>("TravelReport/GetTravelReportVms", this.state.Filter);
        if (result.Code == 0) {
            var travelReportVms = result.Data;
            this.setState({ TravelReportVms: travelReportVms });
        }
        else
            NotificationHelper.showErrorMessage(result.Message)
    }

    openEditTravelReport = () => {
        const url = "TravelReport/Edit?id=" + encodeURIComponent(this.state.SelectedTravelReport.BelegNr);
        const sheet = General.Sheet.Manager.createSheetWithUrl(url);
        sheet.bind(SheetEventType.Close, () => { this.getTravelReportVms() });
        General.Functions.HistoryState.pushSheetState(sheet, url);
    }

    openCreateTravelReport = () => {
        let entity: CreateTravelReportEntity = {
            filter: {
                RessNr: this.state.Filter.RessNr,
                End: this.state.Filter.End
            },
            IsNew: true,
            RecordRight: this.props.entity.RecordRight,
            IsWatchable: this.props.entity.IsWatchable,
            IsWatched: this.props.entity.IsWatched,
        }
        this.openCreateTravelReportWindow(entity);
    }

    deleteTravelReport = async () => {
        let isOk = await DialogHelper.confirm(Config.translations.deleteMessage);
        if (isOk) {
            let result = await HTTPService.post<JsonResultClass>("TravelReport/DeleteTravelReport?belegNr=" + this.state.SelectedTravelReport.BelegNr);
            if (result.Code == 0) {
                NotificationHelper.showSuccessMessage(this.translations["Ressource.LöschenErfolgreich"]);
                this.getTravelReportVms();
            }
            else
                NotificationHelper.showErrorMessage(result.Message);
        };
    }

    openCreateTravelReportWindow = async (entity: CreateTravelReportEntity) => {
        let cloneContext: Context = JSON.parse(JSON.stringify(this.props.context));
        cloneContext.contextType = "createTravelReport";
        let metaData = await Helper.getMetaData("createTravelReport");

        const sheet = General.Sheet.Manager.createSheet();
        sheet.setTitle(this.translations["WebSMS.TravelReport.NewTravelReport"]);
        sheet.show(() => {
            const props: CreateTravelReportProps = {
                context: cloneContext,
                dataSources: this.props.dataSources,
                title: this.translations["WebSMS.TravelReport.NewTravelReport"],
                metadata: metaData,
                entity: entity,
                isWindow: true
            };
            sheet.mountContent(CreateTravelReportApp, props);
            sheet.bind(SheetEventType.Close, () => { this.getTravelReportVms() })
        })
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case "entity.Filter.Start":
                this.handleFilterChange(field, value);
                break;
            case "entity.Filter.End":
                this.handleFilterChange(field, value);
                break;
            case "entity.Filter.RessNr":
                this.handleFilterChange(field, value);
                break;
            case "entity.Filter.NotApproved":
                this.handleFilterChange(field, value);
                break;
            case "entity.Filter.NotInvoiced":
                this.handleFilterChange(field, value);
                break;
            case "entity.Filter.NotCompleted":
                this.handleFilterChange(field, value);
                break;
        }
        this.common.setEntityDirtyState(false);
    }

    handleFilterChange(field: { model: string }, value) {
        var filter = this.state.Filter;
        switch (field.model) {
            case "entity.Filter.Start":
                filter.Start = value;
                break;
            case "entity.Filter.End":
                filter.End = value;
                break;
            case "entity.Filter.RessNr":
                filter.RessNr = value;
                break;
            case "entity.Filter.NotApproved":
                filter.NotApproved = value;
                break;
            case "entity.Filter.NotInvoiced":
                filter.NotInvoiced = value;
                break;
            case "entity.Filter.NotCompleted":
                filter.NotCompleted = value;
                break;
        }
        this.setState({ Filter: filter }, this.getTravelReportVms);
    }

    handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: TravelReportEntity) => {
        if (type === ToolBarStandardButtonType.EDIT) {
            this.openEditTravelReport();
        }
        else if (type === ToolBarStandardButtonType.NEW) {
            this.openCreateTravelReport();
        }
        else if (type === ToolBarStandardButtonType.DELETE) {
            this.deleteTravelReport();
        }
    }

    private handleDataBound = (e) => {
        var data = e.sender.dataSource.view();
        for (var i = 0; i < data.length; i++) {
            if (data[i].IsReportedBackExternally) {
                var row = e.sender.tbody.find("tr[data-uid='" + data[i].uid + "']");
                var cell = $("td[data-field='StatusRText']", row);
                cell.css("background-color", "#558B2F");
                cell.css("color", "white");
            }

            if (data[i].IsExternIncomplete) {
                var row = e.sender.tbody.find("tr[data-uid='" + data[i].uid + "']");
                var cell = $("td[data-field='StatusRText']", row);
                cell.css("background-color", "#FF9800");
                cell.css("color", "white");
            }

            if (data[i].HasIncorrectData) {
                var row = e.sender.tbody.find("tr[data-uid='" + data[i].uid + "']");
                var cell = $("td[data-field='StatusRText']", row);
                cell.css("background-color", "#ef5350");
                cell.css("color", "white");
            }
        }
    }

    renderGrid = () => {
        if (!Helper.hasValue(this.state.TravelReportVms))
            return null;
        let deleteCondition = this.state.SelectedTravelReport != null && !this.state.SelectedTravelReport.IsReleasedCommercial && !this.state.SelectedTravelReport.IsInvoiced && this.props.entity.RecordRight.CanWrite;
        let standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: true });
        standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: deleteCondition });

        return (<div className="flex-container__item" style={{ marginTop: 5 }}>
            <Grid
                id="travelReportList"
                data={this.state.TravelReportVms}
                options={this.travelReportGridOptions}
                standardButtons={standardButtons}
                onClickStandardButton={this.handleClickStandardButton}
                onSelectionChanged={(dataItem: TravelReportEntity) => { this.setState({ SelectedTravelReport: dataItem }) }}
                onDataBound={this.handleDataBound}
            />
        </div>);
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

export interface TravelReportSearchProps extends AppBaseProps {
    entity: TravelReportSearchEntity;
}

export interface TravelReportSearchState {
    Filter: TravelReportFilter;
    TravelReportVms: TravelReportEntity[];
    SelectedTravelReport: TravelReportEntity;
}

export interface TravelReportSearchEntity extends Entity {
    Filter: TravelReportFilter;
    RecordRight: TravelReportRights;
}